exports = module.exports = require("../../../node_modules/_css-loader@0.28.4@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ndiv{\n\tbackground: #fff;\n}\n", "", {"version":3,"sources":["D:/daima/nodejs/angular/news/Pretty-Talks/pretty/app/router/router/pfilist.vue?51e19350"],"names":[],"mappings":";AAkBA;CACA,iBAAA;CACA","file":"pfilist.vue","sourcesContent":["<template>\r\n\t<div>\r\n\t\t<plist></plist>\r\n\t\t<router-view></router-view>\r\n\t</div>\r\n\t\t\r\n</template>\r\n\r\n<script >\r\n\timport plist from '../../component/plist.vue';\r\n\texport default{\r\n\t\tcomponents:{\r\n\t\t\tplist,\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style>\r\n\tdiv{\r\n\t\tbackground: #fff;\r\n\t}\r\n</style>"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.4@css-loader?sourceMap!./node_modules/_vue-loader@12.2.2@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4882f850","scoped":false,"hasInlineConfig":false}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=styles&index=0!./app/router/router/pfilist.vue
// module id = 313
// module chunks = 0